var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "px-0", attrs: { id: "userSettings", fluid: "" } },
    [
      _c(
        "portal",
        { attrs: { to: "page-title" } },
        [
          _c("v-breadcrumbs", {
            attrs: {
              items: [
                { text: _vm.$tc("labels.user", 2), disabled: false },
                { text: _vm.$tc("labels.setting", 2), disabled: false }
              ]
            },
            scopedSlots: _vm._u([
              {
                key: "divider",
                fn: function() {
                  return [
                    _c("v-icon", { attrs: { size: "8" } }, [
                      _vm._v("\n          far fa-chevron-right\n        ")
                    ])
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _c(
        "v-card",
        { staticClass: "mx-10 my-3 settings", attrs: { elevation: "4" } },
        [
          _c("ValidationObserver", {
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var invalid = ref.invalid
                  var passes = ref.passes
                  return [
                    _c(
                      "v-container",
                      { staticClass: "pa-4", attrs: { fluid: "" } },
                      [
                        _c(
                          "v-row",
                          { attrs: { dense: "" } },
                          [
                            _c("v-col", [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "body-2 font-weight-medium text--grey text--darken-3"
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("labels.profileStateChanges")
                                      ) +
                                      "\n            "
                                  )
                                ]
                              )
                            ])
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          { attrs: { dense: "" } },
                          [
                            _c("v-col", { staticClass: "py-0" }, [
                              _c("span", {
                                staticClass:
                                  "caption grey--text text--darken-1",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t(
                                      "descriptions.profileStateChangesInactive"
                                    )
                                  )
                                }
                              })
                            ])
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          { staticClass: "my-2", attrs: { dense: "" } },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "state-flags pr-4",
                                attrs: { cols: "6" }
                              },
                              [
                                _c("FlagSelection", {
                                  ref: "selectShiftFlag",
                                  staticClass: "shift-flags",
                                  attrs: {
                                    "small-chips": "",
                                    dense: "",
                                    filter: _vm.flagsFilter,
                                    "hide-details": "",
                                    "item-text": "shortCode",
                                    "item-value": "id",
                                    items: _vm.shiftFlags,
                                    label: _vm.$tc("labels.flag", 2),
                                    multiple: "",
                                    outlined: "",
                                    "return-object": false
                                  },
                                  model: {
                                    value: _vm.states.inactive.flags,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.states.inactive,
                                        "flags",
                                        $$v
                                      )
                                    },
                                    expression: "states.inactive.flags"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          { attrs: { dense: "" } },
                          [
                            _c("v-col", { staticClass: "py-0" }, [
                              _c("span", {
                                staticClass:
                                  "caption grey--text text--darken-1",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t(
                                      "descriptions.profileStateChangesSevered"
                                    )
                                  )
                                }
                              })
                            ])
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          { staticClass: "my-2", attrs: { dense: "" } },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "state-flags pr-4",
                                attrs: { cols: "6" }
                              },
                              [
                                _c("FlagSelection", {
                                  ref: "selectShiftFlag",
                                  staticClass: "shift-flags",
                                  attrs: {
                                    "small-chips": "",
                                    dense: "",
                                    filter: _vm.flagsFilter,
                                    "hide-details": "",
                                    "item-text": "shortCode",
                                    "item-value": "id",
                                    items: _vm.shiftFlags,
                                    label: _vm.$tc("labels.flag", 2),
                                    multiple: "",
                                    outlined: "",
                                    "return-object": false
                                  },
                                  model: {
                                    value: _vm.states.severed.flags,
                                    callback: function($$v) {
                                      _vm.$set(_vm.states.severed, "flags", $$v)
                                    },
                                    expression: "states.severed.flags"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("v-divider"),
                    _c(
                      "v-row",
                      { staticClass: "pa-4", attrs: { dense: "" } },
                      [
                        _c("v-spacer"),
                        _c(
                          "v-col",
                          { staticClass: "text-right", attrs: { cols: "6" } },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "ml-3 save-settings",
                                attrs: {
                                  color: "secondary",
                                  disabled: invalid || _vm.saving
                                },
                                on: {
                                  click: function($event) {
                                    return passes(_vm.save)
                                  }
                                }
                              },
                              [
                                _vm.saving
                                  ? _c("v-progress-circular", {
                                      attrs: {
                                        color: "secondary",
                                        indeterminate: "",
                                        size: "22",
                                        width: "2"
                                      }
                                    })
                                  : _c("span", [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.$t("labels.save")) +
                                          "\n            "
                                      )
                                    ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }